// extracted by mini-css-extract-plugin
module.exports = {"root":"LabeledBox_root__VAetM","label":"LabeledBox_label__2dJZN"};